import ThisModule from "./PagePrivacyPolicy";

export default ThisModule;
